// extracted by mini-css-extract-plugin
export default {"card":"QZ-z","carouselContainer":"RZ-z","carouselContent":"SZ-z"};